import { CheckAnswerCardPage } from './CheckAnswerCardPage';
export default CheckAnswerCardPage;
